<template>
  <div>
    <chat-message-toast />
    <v-navigation-drawer
      v-model="drawerOpen"
      fixed
      temporary
      left
      :width="drawerWidth"
      elevation="0"
      class="user-conversation-drawer"
      :class="{
        'user-conversation-drawer--mobile': isMobileLayout,
        'user-conversation-drawer--mobile-detail':
          isMobileLayout && mobilePane === 'detail',
      }"
    >
      <div class="user-conversation-drawer-inner">
        <div class="user-conversation-drawer-header">
          <v-card-text class="pa-0">{{ $t("conversations") }}</v-card-text>
          <v-icon style="cursor: pointer" @click="drawerOpen = false">
            mdi-close
          </v-icon>
        </div>
        <div class="user-conversation-drawer-body">
          <Conversation
            v-if="drawerOpen"
            :focus-chat-id="focusChatId"
            :focus-message-id="focusMessageId"
            @mobile-pane="onMobilePane"
          />
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Conversation from "@/views/dashboard/components/general/conversation/Conversation.vue";
import ChatMessageToast from "@/views/dashboard/components/core/partial/ChatMessageToast.vue";

export default {
  components: {
    Conversation,
    ChatMessageToast,
  },
  data() {
    return {
      drawerOpen: false,
      focusChatId: null,
      focusMessageId: null,
      mobilePane: "list",
    };
  },
  computed: {
    isMobileLayout() {
      return (
        this.$vuetify &&
        this.$vuetify.breakpoint &&
        this.$vuetify.breakpoint.width < 800
      );
    },
    drawerWidth() {
      return this.isMobileLayout ? "100%" : 820;
    },
  },
  created() {
    this.$root.$on("open-user-conversation", this.openDrawer);
  },
  beforeDestroy() {
    this.$root.$off("open-user-conversation", this.openDrawer);
  },
  watch: {
    drawerOpen(val) {
      if (!val && this.$root) {
        this.$root.$emit("chat-active-changed", null);
        this.focusChatId = null;
        this.focusMessageId = null;
        this.mobilePane = "list";
      }
    },
  },
  methods: {
    openDrawer(payload) {
      var data = payload && typeof payload === "object" ? payload : null;
      if (data && data.chatId != null) {
        this.focusChatId = data.chatId;
        this.focusMessageId =
          data.messageId != null ? data.messageId : null;
      } else {
        this.focusChatId = null;
        this.focusMessageId = null;
      }
      this.mobilePane = "list";
      this.drawerOpen = true;
    },
    onMobilePane(pane) {
      this.mobilePane = pane === "detail" ? "detail" : "list";
    },
  },
};
</script>

<style>
.user-conversation-drawer,
.user-conversation-drawer .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
.user-conversation-drawer.v-navigation-drawer {
  box-shadow: none !important;
  z-index: 10 !important;
  height: 100% !important;
  top: 0 !important;
  max-height: 100% !important;
  border-right: 1px solid #e5e5e5;
}
.user-conversation-drawer-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.user-conversation-drawer-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}
.user-conversation-drawer-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

@media (max-width: 799px) {
  .user-conversation-drawer.v-navigation-drawer {
    z-index: 12 !important;
    width: 100% !important;
    max-width: 100% !important;
    border-right: 0;
  }
  .user-conversation-drawer-header {
    padding: 12px 14px;
    padding-top: calc(12px + env(safe-area-inset-top, 0px));
  }
  .user-conversation-drawer--mobile-detail .user-conversation-drawer-header {
    display: none;
  }
}
</style>
